module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "150px"
    }
  }, [_vm._v("Acknowledgement")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("We thank the editorial team at Austin Macauley, without whom this book would not have been published. Many thanks, also, to the entire production staff for their sterling work.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("We are especially grateful to Brenda DeFazio (Rob’s wife) for her two patient proofreadings and many stylistic suggestions. Her part in shaping and grooming our manuscript was valuable beyond measure.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0